import React, { useEffect } from 'react';

import { bool } from 'prop-types';

import { useParams, useSearchParams } from 'react-router-dom';

import useRedirect from 'hooks/useRedirect';
import {
  ACCOUNT_SETTINGS_MY_STUDENTS,
  ADD_AFFILIATION,
  CANDIDATE_SOURCED_DETAILS,
  RECOMMENDATION_LETTER_PORTAL,
} from 'routes/constants';

/**
 * Contains all redirect logic strictly for member users
 */
const RedirectHelper = ({
  isNewsfeedRedirect,
  isOnboardingGuardianRedirect,
  isAddAffiliationRedirect,
  isBYOPRedirect,
  isRecommenderRedirect,
}) => {
  const { redirect } = useRedirect();
  const { hashId, placementHashId, programId } = useParams();
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('eventId');
  const districtId = searchParams.get('districtId');

  useEffect(() => {
    const guardianClaimCode = sessionStorage.getItem('guardianClaimCode');
    const forceNewsfeedRedirect = JSON.parse(
      sessionStorage.getItem('forceNewsfeedRedirect') || 'false',
    );
    if (isAddAffiliationRedirect && !forceNewsfeedRedirect) {
      redirect({
        to: ADD_AFFILIATION({ params: { eventId, districtId } }),
        component: 'routes/MemberRoutes/RedirectHelper',
        reason:
          'Redirecting member user to add affiliation page after onboarding',
      });
    }
    if (isNewsfeedRedirect) {
      redirect({
        to: '/newsfeed',
        component: 'routes/MemberRoutes/RedirectHelper',
        reason:
          'Redirecting member user to from (/dashboard or /) to /newsfeed',
      });
    }
    if (
      (isOnboardingGuardianRedirect && !forceNewsfeedRedirect) ||
      guardianClaimCode
    ) {
      sessionStorage.removeItem('guardianClaimCode');
      redirect({
        reason:
          'Guardian is using the claim link /onboarding/guardian/<student_hash_id>',
        to: `${ACCOUNT_SETTINGS_MY_STUDENTS}/${hashId}`,
        component: 'routes/MemberRoutes/index.js',
      });
    }
    if (isBYOPRedirect) {
      redirect({
        to: CANDIDATE_SOURCED_DETAILS({
          placementHashId,
          programId,
        }),
        component: 'routes/MemberRoutes/RedirectHelper',
        reason: 'Redirecting member user to candidate sourced byop form',
      });
    }
    if (isRecommenderRedirect) {
      redirect({
        to: RECOMMENDATION_LETTER_PORTAL,
        reason:
          'Redirect member to recommendation letter portal after claiming account',
        component: 'routes/MemberRoutes/RedirectHelper',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    placementHashId,
    programId,
    isNewsfeedRedirect,
    isOnboardingGuardianRedirect,
    isAddAffiliationRedirect,
    isBYOPRedirect,
  ]);

  return <></>;
};

RedirectHelper.propTypes = {
  isNewsfeedRedirect: bool,
  isOnboardingGuardianRedirect: bool,
  isAddAffiliationRedirect: bool,
  isBYOPRedirect: bool,
  isRecommenderRedirect: bool,
};

RedirectHelper.defaultProps = {
  isNewsfeedRedirect: false,
  isOnboardingGuardianRedirect: false,
  isAddAffiliationRedirect: false,
  isBYOPRedirect: false,
  isRecommenderRedirect: false,
};

export default RedirectHelper;
